import React, { useEffect, useState, useRef } from "react";
import ReactPlayer from "react-player";

const OBBTvComponent = () => {
    const playerRef = useRef(null);
    const [renderKey, setRenderKey] = useState(0);

    useEffect(() => {
        if (playerRef.current) {
            playerRef.current.seekTo(0);
        }

        const intervalId = setInterval(() => {
            setRenderKey(prevKey => prevKey + 1);
        }, 900000); // Change 10000 to the desired interval in milliseconds

        return () => clearInterval(intervalId);
    }, []);

    const onReady = React.useCallback(() => {
        const timeToStart = 0;
        playerRef.current.seekTo(timeToStart, 'seconds');
    }, [playerRef.current]);

    return (
        <div className={"player-wrapper"} key={renderKey}>
            <ReactPlayer
                playing={true}
                onReady={onReady}
                playsinline={true}
                controls={false}
                loop={true}
                muted={true}
                className='react-player'
                width="100%"
                height="100%"
                ref={playerRef}
                url='https://api-tv33.yayin.com.tr/ordubeltv/video.m3u8'
                config={{
                    file: {
                        attributes: {
                            style: {
                                objectFit: 'cover',
                                width: '100%',
                                height: '100%'
                            }
                        }
                    }
                }}
            />
        </div>
    );
}

export default OBBTvComponent;